
import React, { useState, useEffect } from "react";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MenuIcon from '@mui/icons-material/Menu';
import "./ChangePasswordTopButtons.css"
import EditIcon from '@mui/icons-material/Edit';

function ChangePasswordTopButtons() {
  
  return (
    <>
      <div className="d-flex app mobile-top-button-head-hide">
        <div
          className="container-fluid ordersummary-top-button-main"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div className=""
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                height:"48px"
              }}
            >
              <div>
                <h1 className=" p-0" style={{ fontSize: "24px", marginBottom: "2rem"}}>
                  Change Password | <HomeOutlinedIcon style={{color:"#5B489D",width:"34px",height:"27px"}}/>{" "}
                  <span style={{ fontSize: "20px",color:"#6A6A6A" }}>&gt;Change Password</span> {" "}
                </h1>
            
              </div>
            </div>
            <div>

          </div>
        </div>
          </div>
        </div>

        {/* mobile view  */}
        <div className="d-flex app mobile-top-button-head-show">
        <div
          className="container-fluid ordersummary-top-button-main"
          style={{ backgroundColor: "#F4F4F4" }}
        >
          <div
            className="d-flex flex-column w-100"
            style={{ backgroundColor: "#F4F4F4" }}
          >
            <div className="mobile-top-button-head-hide"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                height:"48px"
              }}
            >
            </div>
            {/* mobile view  */}
            <div className="mt-0 p-0"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                height:"31px"
              }}
            >
              <div>
                <h1 className="p-0 text-start" style={{ fontSize: "24px", marginBottom: "2rem"}}>
                  <HomeOutlinedIcon style={{color:"#5B489D",width:"24px",height:"27px"}}/>{" "}
                  <span style={{ fontSize: "16px",color:"#6A6A6A" }}>&gt; Change Password</span> {" "}
                </h1>
            
              </div>
            </div>
            <div>

          </div>
        </div>
          </div>
        </div>
    </>
  );
}

export default ChangePasswordTopButtons;
